<template>
  <SideBar
    :visible="isExtraGuaranteeOpen ?? false"
    :title="t('extra-guarantee.title')"
    @close="extraGuaranteeClickOutside"
  >
    <ExtraGuaranteeInner
      :extra-guarantee-sku="extraGuaranteeSku"
      :product-name="productNameForExtraGuarantee ?? ''"
      :product-image="productImageForExtraGuarantee ?? ''"
      @update:selected-option="selectedOption = $event"
    />
    <template #content-bottom>
      <CartSidebarButtons
        :disabled="isCartSidebarButtonDisabled"
        :primary-button-text="t('extra-guarantee.accept')"
        :secondary-button-text="t('extra-guarantee.refuse')"
        @primary-button-click="handleAcceptExtraGuarantee"
        @secondary-button-click="handleRefuseExtraGuarantee()"
      />
    </template>
  </SideBar>
</template>

<script setup lang="ts">
defineOptions({ name: 'ExtraGuaranteeSidebar' });

const { t } = useI18n();
const { isExtraGuaranteeOpen } = useUiState();
const { handleExtraGuaranteeLogic } = useCartSidebars();
const {
  skuForExtraGuarantee,
  productNameForExtraGuarantee,
  productImageForExtraGuarantee,
  extraGuaranteeLineItem,
} = useExtraGuarantee();
const { productsExtraGuarantee } = useProductsExtraGuaranteeStore();

const {
  addExtraGuaranteeProduct,
  removeItem,
  cart,
} = useCartExtended();

const selectedOption = ref(null);
const addingExtraGuarantee = ref(false);

const extraGuaranteeClickOutside = () => {

  handleExtraGuaranteeLogic(skuForExtraGuarantee.value ?? '');

};

const extraGuaranteeSku = computed(() => extraGuaranteeLineItem.value?.variant?.sku || '');

const isCartSidebarButtonDisabled = computed(
  () => (!selectedOption.value && (productsExtraGuarantee.value?.length ?? 0) !== 1) || addingExtraGuarantee.value,
);

const removePreviousExtraGuaranteeProduct = async () => {

  const previousSelectedGuaranteeProduct = cart.value?.lineItems.find(item =>
    item.custom?.customFieldsRaw?.[0]?.value === skuForExtraGuarantee.value);

  if (previousSelectedGuaranteeProduct) {

    await removeItem({ product: previousSelectedGuaranteeProduct });

  }

};

const handleAcceptExtraGuarantee = async () => {

  addingExtraGuarantee.value = true;
  const guaranteeSku = selectedOption?.value ? selectedOption.value : '';
  await removePreviousExtraGuaranteeProduct();
  await addExtraGuaranteeProduct(skuForExtraGuarantee.value ?? '', guaranteeSku);
  addingExtraGuarantee.value = false;
  handleExtraGuaranteeLogic(skuForExtraGuarantee.value ?? '');

};

const handleRefuseExtraGuarantee = async () => {

  await removePreviousExtraGuaranteeProduct();
  handleExtraGuaranteeLogic(skuForExtraGuarantee.value ?? '');

};
</script>
